import { Button } from "primereact/button";
import React, { useState } from "react";
import "./TooltipAlias.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { faApple, faWindows } from "@fortawesome/free-brands-svg-icons";
import { FormattedMessage } from "react-intl";

function Tooltip() {
  const [isVisible, setIsVisible] = useState(false);

  const toggleTooltip = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div style={{ position: "relative" }}>
      <Button
        icon="pi pi-question-circle"
        onClick={toggleTooltip}
        className="readysize-tooltip-container"
      />

      {isVisible && (
        <div
          className="tooltip-content"
          style={{
            position: "absolute",
            backgroundColor: "white",
            padding: "15px 20px 15px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            zIndex: 1000,
            right: "-400px",
            width: "400px",
            height: "300px",
            top: "-100px",
          }}
        >
          <div>
            <p>
              <FormattedMessage
                id="aliasTooltip"
                defaultMessage="Para agregar mas alias a tu producto hace click sobre el boton que
              dice pega aqui tus alias, una vez seleccionado pega tus codigos de
              guias desde excel o word (control + v en Windows) o (command + v
              en Mac)"
              />
              {/* Para agregar mas alias a tu producto hace click sobre el boton que
              dice pega aqui tus alias, una vez seleccionado pega tus codigos de
              guias desde excel o word (control + v en Windows) o (command + v
              en Mac) */}
            </p>
            <div className="tooltipalias-icon-container">
              <div className="tooltipalias-icon">
                <FontAwesomeIcon icon={faWindows} />
              </div>
              <div className="alias-flex-container">
                <button className="button-56">Ctrl</button>
                <p className="alias-plus">+</p>
                <button className="button-56">V</button>
              </div>
            </div>
            <div className="tooltipalias-icon-container">
              <div className="tooltipalias-icon">
                <FontAwesomeIcon icon={faApple} />
              </div>
              <div className="alias-flex-container">
                <button className="button-56">⌘</button>
                <p className="alias-plus">+</p>
                <button className="button-56">V</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Tooltip;
